module.exports = __webpack_public_path__ + "colorBlur.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colorBlur.jpg
// module id = 879
// module chunks = 0